module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.id,
      staticClass: "list-group-item navigatable",
      attrs: {
        "to": {
          name: 'products.view',
          params: {
            id: product.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action"
    }), _vm._v("\n\n            " + _vm._s(product.name)), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(product.price) + ",- DKK")])])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Products\n\n            "), _c('small', [_c('button', {
    staticClass: "btn btn-default btn-fill btn-sm"
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d65c18a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/Products.vue
// module id = 394
// module chunks = 1